export default "__VITE_ASSET__ClwCvxvq__"